import { Unionize } from "fond/types";

export const SidebarSection = ["starred", "shared", "recent", "main"] as const;
export type SidebarSection = Unionize<typeof SidebarSection>;
